module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_2_2-896c85a0be96132e6d838099e337ce70.webp";